module.exports = __webpack_public_path__ + "static/img/4490_phase_function_Paper_PointsHejduk_Prediction.0cdc63c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4490_phase_function_Paper_PointsHejduk_Prediction.png
// module id = r0l8
// module chunks = 0